// YERİ: src/app/domains/site/sections/member-login.section.ts
// Müşteri Girişi — ziyaretçi (müşterinin müşterisi) CC üye portalına bağlanır.
// id="member-login" → header "Müşteri Girişi" butonu buraya kayar.
//
// ── ADRES NEREDEN GELİYOR ───────────────────────────────────────────────────
// Önceden `loginUrl` yalnız config'ten okunuyordu ve varsayılanı '#' idi:
// şablonlar bu alanı doldurmadığı için buton HİÇBİR YERE gitmiyordu — tıklayan
// ziyaretçi aynı sayfada kalıyordu.
//
// Artık config boşsa adres kendiliğinden üretiliyor — bkz. memberPortalUrl().
// Kendi alan adı / alt alan adı olan kiracı `loginUrl`'ü doldurup ezebilir.
//
// NOT (dağıtım): `/member` yolu üye portalı uygulamasına yönlendirilmelidir
// (`/api` → .NET, `/` → SSR düğümü kuralının yanına).

import { Component, computed, inject, input } from '@angular/core';
import { SiteChromeText } from '../core/site-chrome-text';
import { MIcon } from '@/app/shared/ui/m-icon';
import { memberPortalUrl } from '../core/member-portal-url';
import { SiteConfig, cfg } from './section.model';

@Component({
  selector: 'sec-member-login',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="member-login" class="bg-neutral-50 py-20 dark:bg-neutral-900">
      <div class="mx-auto max-w-3xl px-6 text-center lg:px-8">
        <span class="mx-auto flex size-14 items-center justify-center rounded-2xl text-white" style="background-color:var(--site-primary)">
          <m-icon name="user-round" />
        </span>
        <h2 class="mt-5 font-[family-name:var(--site-head-font)] text-2xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-3xl">{{ title() }}</h2>
        @if (subtext()) { <p class="mx-auto mt-3 max-w-xl text-neutral-600 dark:text-neutral-400">{{ subtext() }}</p> }
        <a [href]="loginUrl()" [target]="newTab() ? '_blank' : '_self'" [attr.rel]="newTab() ? 'noopener' : null"
           class="mt-7 inline-flex items-center justify-center gap-2 rounded-lg px-7 py-3.5 text-sm font-semibold text-white shadow-lg transition hover:opacity-90"
           style="background-color:var(--site-accent)">
          <m-icon name="log-in" size="sm" /> {{ buttonText() }}
        </a>
      </div>
    </section>
  `,
})
export class MemberLoginSection {
  config = input<SiteConfig>({});
  protected title = computed(() => cfg(this.config(), 'title', 'Müşteri Portalı'));
  protected subtext = computed(() => cfg(this.config(), 'subtext', 'Mevcut müvekkillerimiz; dosya durumu, belgeler ve randevular için müşteri portalına giriş yapabilir.'));
  private chrome = inject(SiteChromeText);

  protected buttonText = computed(() =>
    cfg(this.config(), 'buttonText', '') || this.chrome.t('ml.login'));
  /** Kiracı kimliği — otomatik portal adresi için (host geçirir). */
  clientId = input<number>(0);
  /** Şirketin genel kimliği — bağlantı bunu taşır (bkz. memberPortalUrl). */
  companyUid = input<string | null>(null);

  protected loginUrl = computed(() => {
    const ozel = String(cfg(this.config(), 'loginUrl', '')).trim();
    if (ozel && ozel !== '#') return ozel;
    return memberPortalUrl(this.companyUid(), this.clientId());
  });
  /** Yeni sekmede aç — varsayılan evet (portal ayrı sekmede mantıklı). */
  protected newTab = computed(() => String(cfg(this.config(), 'newTab', 'true')).toLowerCase() !== 'false');
}
